import React from 'react';

const Funnel = ({ width = 24, height = 24, color = '#000' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V6C21 6.26522 20.8946 6.51957 20.7071 6.70711L15 12.4142V18C15 18.3797 14.842 18.7395 14.5607 19.0208L12.5607 21.0208C12.3674 21.2141 12.1326 21.3333 11.8787 21.3612C11.6249 21.389 11.3704 21.3246 11.1552 21.1789C10.94 21.0331 10.7784 20.816 10.6929 20.5607C10.6074 20.3054 10.6035 20.0273 10.6821 19.7714L12 15.4142V12.4142L6.29289 6.70711C6.10536 6.51957 6 6.26522 6 6V4C6 3.44772 6.44772 3 7 3H4C3.44772 3 3 3.44772 3 4Z"
                fill={color}
            />
        </svg>
    );
};

export default Funnel;
